import NavigationBar from "../navigation/nav-bar/navigationBar";
import StudentLifeBodyComponent from "./studentLifeBodyComponent";
import FooterComponent from "../navigation/footer/footerComponent";


export default function MainStudentLifeComponent(props) {

    return (
        <div>
            <NavigationBar />
            <StudentLifeBodyComponent />
            <FooterComponent />
        </div>
    )
}